import React from 'react';
import { Link } from 'react-router-dom';

export default function ServiceCard({ id, title, description, icon, image }) {
  return (
    <Link to={`/services/${id}`}>
      <div className="bg-primary-container/50 backdrop-blur-sm border border-outline-variant/30 rounded-2xl overflow-hidden hover:shadow-lg hover:bg-primary-container/70 transition-all duration-300 cursor-pointer h-full">
        <div className="aspect-video bg-gradient-to-br from-secondary to-primary overflow-hidden relative">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
          {icon && (
            <div className="absolute inset-0 flex items-center justify-center text-white/30">
              <span className="material-symbols-outlined text-6xl">{icon}</span>
            </div>
          )}
        </div>

        <div className="p-6">
          <h3 className="text-headline-md font-bold mb-3 text-on-primary-container">{title}</h3>
          <p className="text-body-md text-on-primary-container/80 line-clamp-3">{description}</p>

          <div className="mt-6 inline-flex items-center gap-2 text-accent font-semibold">
            <span>Learn More</span>
            <span className="material-symbols-outlined text-lg">arrow_forward</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
